export default {"src":"/_next/static/media/setting.77354289.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};